import { Button, ButtonGroup } from "@aws-amplify/ui-react"
import { I18n } from "aws-amplify/utils"
import { useNavigate } from "react-router-dom"
import { RoundedCard } from "../../components"

export function AdminPanel() {
  const navigate = useNavigate()

  function redirectToUsers() {
    navigate(`users`)
  }
  function redirectToOrgs() {
    navigate(`orgs`)
  }
  function RedirectToMachines() {
    navigate(`machines`)
  }

  return (
    <main className="p-8">
      <RoundedCard>
        <ButtonGroup>
          <Button onClick={redirectToUsers}>{I18n.get("Benutzer")}</Button>
          <Button onClick={redirectToOrgs}>{I18n.get("Betriebe")}</Button>
          <Button onClick={RedirectToMachines}>{I18n.get("Maschinen")}</Button>
        </ButtonGroup>
      </RoundedCard>
    </main>
  )
}
